import { schema } from "normalizr";

const DeductionTypeSchema = new schema.Entity("deductionTypes");
const DeductionTypeArraySchema = new schema.Array(DeductionTypeSchema);

export { DeductionTypeSchema, DeductionTypeArraySchema };